import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ubs-order-overview',
  templateUrl: './order-overview.component.html',
  styleUrls: ['./order-overview.component.scss']
})
export class OrderOverviewComponent implements OnInit{
  @Input() data:any;
  orderId:string;
  statusId: string;

  ngOnInit(): void {
    console.log(this.data);
    this.orderId = this.data["orderId"];
    this.statusId = this.data["statusId"];
  }

}
